const DASHBOARD_PREFETCH_ROUTE_PREFIXES = [
  '/',
  '/account',
  '/board',
  '/dashboard',
  '/destinations',
  '/events-manager',
  '/notifications',
  '/orders',
  '/products',
  '/settings',
  '/setup',
] as const;
let hasPrefetchedDefaultDashboardChunk = false;

export function shouldPrefetchDefaultDashboardChunk(pathname: string): boolean {
  return DASHBOARD_PREFETCH_ROUTE_PREFIXES.some(routePrefix =>
    routePrefix === '/'
      ? pathname === '/'
      : pathname.startsWith(routePrefix)
  );
}

export function prefetchDefaultDashboardChunk(pathname: string): void {
  if (
    hasPrefetchedDefaultDashboardChunk ||
    !pathname ||
    !shouldPrefetchDefaultDashboardChunk(pathname)
  ) {
    return;
  }

  hasPrefetchedDefaultDashboardChunk = true;
  void import('@/features/dashboard/overview/dashboard-section');
}

